import {Brand} from '../Brand';
import {chatiwinBase} from './chatiwinBase';
import {ChatiwinLogo} from './ChatiwinLogo';

export const chatiwin: Brand = {
  ...chatiwinBase,
  assets: {
    logo: ChatiwinLogo,
  },
};
